import { render, staticRenderFns } from "./relatorioNaoAcionados.vue?vue&type=template&id=c2faf0e0"
import script from "./relatorioNaoAcionados.vue?vue&type=script&lang=js"
export * from "./relatorioNaoAcionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports